import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full mb-6 md:-mt-2 lg:-mt-8"
}
const _hoisted_2 = { class: "-mx-5 -my-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "material-icons-outlined text-muted mr-2" }
const _hoisted_6 = {
  key: 2,
  class: "flex w-full h-full mt-12"
}
const _hoisted_7 = { class: "m-auto flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10 mx-auto"
}, " book ", -1)
const _hoisted_9 = { class: "opacity-40 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_CourseTreeNode = _resolveComponent("CourseTreeNode")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!
  const _component_CourseTreeNodeEditor = _resolveComponent("CourseTreeNodeEditor")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.canCreateNodes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_DropdownMenu, {
            class: "ml-auto",
            expanded: _ctx.createMenuExpanded,
            onToggleExpanded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createMenuExpanded = !_ctx.createMenuExpanded)),
            label: _ctx.$t('course_tree.new'),
            placement: 'right',
            icon: 'add',
            trailingIcon: 'arrow_drop_down'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeTypesAsSelectableOptions, (nodeType) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                      tabindex: "0",
                      class: "flex pl-4 pr-8 py-2.5 hover:bg-light transition-colors cursor-pointer items-top duration-75",
                      key: nodeType.value,
                      onClick: ($event: any) => (_ctx.onCreateNode(nodeType.value))
                    }, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(nodeType.icons[0]), 1),
                      _createTextVNode(_toDisplayString(nodeType.content), 1)
                    ], 8, _hoisted_4)), [
                      [_directive_wave]
                    ])
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["expanded", "label"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_draggable, {
      modelValue: _ctx.topLevelNodes,
      "ghost-class": "drag-ghost",
      "drag-class": "dragging-element",
      handle: ".drag-handle",
      "item-key": "id",
      onStart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onNodeDragStart($event))),
      onEnd: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onNodeDragEnd($event))),
      animation: "200",
      class: _normalizeClass({ 'dragging-inside-collection': _ctx.mainStore.draggingCourseTreeNode })
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", null, [
          _createVNode(_component_CourseTreeNode, {
            isDraggable: _ctx.canEditNodes,
            class: "my-4",
            onLoadChildren: _cache[1] || (_cache[1] = ($event: any) => (
							_ctx.onLoadChildren(
								$event.node,
								$event.fromFirstPage,
								$event.resolveFn,
								$event.rejectFn,
							)
						)),
            onLoadComments: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onLoadComments($event))),
            canEdit: _ctx.canEditNodes,
            node: element,
            onEditNode: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onEditNode($event))),
            onDeleteNode: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDeleteNode($event)))
          }, null, 8, ["isDraggable", "canEdit", "node"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_VueEternalLoading, {
          key: 1,
          load: _ctx.onLoadMore,
          "is-initial": _ctx.isInitialInfiniteLoad,
          "onUpdate:is-initial": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
        }, {
          loading: _withCtx(() => [
            _createVNode(_component_Spinner)
          ]),
          "no-more": _withCtx(() => [
            _createTextVNode("   ")
          ]),
          _: 1
        }, 8, ["load", "is-initial"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.topLevelNodes.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("course_tree.no_nodes")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      fullHeight: _ctx.fullHeightDialog,
      large: _ctx.largeDialog,
      fullWidth: _ctx.fullScreenDialog,
      onNo: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onDismissNodeEditor())),
      showDialog: _ctx.showEditorDialog,
      showActions: false,
      dismissible: _ctx.autoSaveEditingNode,
      loading: _ctx.editorDialogLoading
    }, {
      body: _withCtx(() => [
        (_ctx.editingNode)
          ? (_openBlock(), _createBlock(_component_CourseTreeNodeEditor, {
              key: 0,
              class: "text-darkText",
              saving: _ctx.saving,
              savingError: _ctx.savingError,
              blockingSaving: _ctx.blockingSaving,
              modelValue: _ctx.proxyEditingNode,
              showAutoSaveIndicator: _ctx.autoSaveEditingNode,
              uploadProgress: _ctx.fileUploadProgress,
              isExistingNode: !!_ctx.editingNode.id,
              onPatchNode: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onEditingNodeChange($event.key, $event.value, !!$event.save))),
              onSave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onEditingNodeSave())),
              onCloseEditor: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onDismissNodeEditor())),
              onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onEditorBlur())),
              onDeleteNode: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onDeleteNode($event))),
              onUpdateState: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onEditingNodeStateUpdate($event)))
            }, null, 8, ["saving", "savingError", "blockingSaving", "modelValue", "showAutoSaveIndicator", "uploadProgress", "isExistingNode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["fullHeight", "large", "fullWidth", "showDialog", "dismissible", "loading"])
  ]))
}